module.exports = __webpack_public_path__ + "static/media/eye-close-icon.5c7d3b32.svg";